var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeDeposit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.4 49.48h-1.792a37 37 0 00-14.758 3.07l-2.843 1.238H36.04a3 3 0 00-3 2.999v.892a3 3 0 003 3.001h10.44",
    stroke: "#10C98E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64 67V54l-7 13h7zM30.5 29.5l-8.5 16-2-4V35l2.5-5.5 2.5-2 5.5 2z",
    fill: "#E1F8F1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4 66.28h-1.583a16 16 0 00-5.61 1.016L45.763 71.58a9 9 0 01-7.367-.475L16.811 59.68a2.766 2.766 0 01-.947-4.065v0a2.766 2.766 0 013.129-1L33.6 59.56M71.12 45H64.4v25.76h6.72z",
    stroke: "#10C98E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.043 14.61c-2.64 5.163-.596 11.489 4.567 14.13a10.5 10.5 0 002.89.982c.166.03 9.333-3.113 9.5-3.091a10.5 10.5 0 001.74-2.458c2.64-5.163.596-11.49-4.567-14.13-5.163-2.64-11.49-.596-14.13 4.567z",
    fill: "#FFF7EE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31 29.802a10.483 10.483 0 01-3.39-1.063c-5.163-2.64-7.208-8.966-4.567-14.13 2.64-5.162 8.967-7.207 14.13-4.566 5.163 2.64 7.207 8.967 4.566 14.13A10.5 10.5 0 0140 26.63",
    stroke: "#7E776E",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.326 21.234a1 1 0 00-1.44 1.387l1.44-1.387zm.845 1.862l.46-.888-.004-.002-.456.89zm2.755-.39l.8.601-.8-.6zm.235-1.954l.92-.394-.002-.003-.918.397zm-1.405-1.386l-.615.788.007.005.608-.793zm-.98-1.317l-.977.215.002.007.975-.222zm.341-1.617l-.8-.6-.003.005.803.595zm2.756-.39l-.459.89.459-.89zm.828 1.846a1 1 0 001.473-1.353L34.7 17.888zm-6.095 4.04l-.72.693.002.002.003.003a.687.687 0 00.041.042l.109.105c.09.087.22.205.38.339.314.262.769.605 1.293.874l.913-1.78a5.184 5.184 0 01-.922-.628 6.309 6.309 0 01-.377-.343l-.003-.003.001.001-.72.694zm1.104 2.056c.58.3 1.294.467 2 .405.721-.063 1.485-.374 2.016-1.082l-1.6-1.2c-.12.16-.309.265-.59.29a1.723 1.723 0 01-.905-.189l-.92 1.776zm4.016-.677c.635-.846.77-1.981.354-2.95l-1.838.79c.134.31.09.686-.116.96l1.6 1.2zm.353-2.952c-.218-.504-.562-.867-.873-1.136-.278-.242-.655-.503-.842-.647l-1.216 1.587c.33.254.521.374.749.571.195.17.295.3.347.42l1.835-.795zm-1.708-1.778c-.403-.314-.572-.54-.62-.75l-1.95.444c.21.92.863 1.512 1.34 1.883l1.23-1.577zm-.618-.743a1.024 1.024 0 01.168-.807l-1.607-1.19a3.023 3.023 0 00-.515 2.427l1.954-.43zm.164-.802c.18-.24.356-.323.531-.346.204-.026.522.017.966.246l.917-1.778c-.677-.35-1.411-.546-2.142-.45-.76.099-1.4.5-1.871 1.128l1.6 1.2zm1.498-.1a5.153 5.153 0 011.287.957v0H34.7l.736-.677.737-.677-.001-.001-.002-.002a7.147 7.147 0 00-1.84-1.378l-.916 1.778z",
    fill: "#7E776E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.088 23.794l-.809 1.583M35.184 13.869l-.791 1.539",
    stroke: "#7E776E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5 49s1-.5 2-1.5 2-3 2-3 3.002.5 4.501 0c1.5-.5 2.667-7.162 2-8.5-.668-1.338-4-1.5-4-1.5s-.48-1.88-1-3c-.48-1.032-2.501-3-2.501-3 2-1.5 4-4.5 2.5-5 0 0-1.2-.547-3-.5-1.61.042-4 1-4 1s-.912-1.217-2.5-1.752M30.5 54.5s-6.5-3.5-9-10a19.193 19.193 0 01-.923-3.161M20 36c0-3 1.5-6 3.29-7.248M42.844 27.066C37.5 25.5 31 28 29.196 32.492",
    stroke: "#376E66",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    transform: "matrix(-1 0 0 1 49.5 33.5)",
    fill: "#376E66"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6 38.662c-.92.463-2.856.343-3.863-.13-.75-.353-1.845-1.252-2.113-1.98-.454-1.233.643-3.413 2.203-3.205 1.05.139 1.239 1.134 1.013 1.591-.388.788-1.785 1.478-2.739 1.568-1.908.18-2.944-.593-4.02-1.8",
    stroke: "#376E66",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgHomeDeposit;